<template>
    <div class="article-box">
        <div class="left-box">
            <div class="shop-box white-bg">
                <div class="news-title"><span class="weizhi">您现在的位置是：<a href="../index.html">首页</a>><a href="../index.html">图片内容页</a></span>
                    <h2>商品详情页</h2>
                </div>

                <!-- Swiper -->
                <div class="shop-view">
                    <img src="../../assets/images/pic06.jpg"  alt="" style="width: 100%">
                </div>
                <div class="product">
                    <h1>商品名称：索尼数码相机DSC-T2</h1>
                    <p class="product-desc"><span>商品简介：</span>镜头。卡尔·蔡司镜头 (Vario-Tessar)，镜头结构：9组11片（包括3片非球面镜，1片棱镜）。光学变焦：3倍</p>
                    <p class="product-scj"><span>市场价：</span><em>￥123.00</em></p>        <p><span>优惠价：</span>￥100.00</p>        <p><span>点数：</span>￥100</p>        <a class="btn-add" href="#ecms" onclick="window.open('/e/ShopSys/doaction.php?enews=AddBuycar&amp;classid=28&amp;id=19','','width=680,height=500,scrollbars=yes,resizable=yes');">加入购物车</a> </div>
                <div class="clear"></div>
                <div class="product-infos">
                    <div class="news-title">
                        <h2>商品详情</h2>
                    </div>
                    <div class="product-content">
                        <h2>* 镜头</h2>
                        <p>卡尔&middot;蔡司镜头 (Vario-Tessar)</p>
                        <p>镜头结构：9组11片（包括3片非球面镜，1片棱镜）</p>
                        <p>光学变焦：3倍</p>
                        <p>动态影像光学变焦</p>
                        <p>F值：3.5-4.3</p>
                        <p>焦距：f=（35mm换算） 6.33-19.0mm(38-114mm)</p>
                        <p>对焦范围 自动对焦：W：约50cm到&infin;，T：约50cm到&infin;</p>
                        <p>微距自动对焦：W：约8cm到&infin;，T：约25cm到&infin;</p>
                        <p>放大镜模式：W：约1cm到约20cm</p>
                        <h2>* 影像传感器</h2>
                        <p>&nbsp;</p>
                        <p>传感器类型：CCD</p>
                        <p>传感器尺寸：1/2.5&rdquo; (7.18mm)</p>
                        <p>总像素（万）：约 828万像素</p>
                        <p>有效像素（万）：约 808万像素</p>
                        <p>Super HAD</p>
                        <h2>* 相机功能</h2>
                        <p>&nbsp;</p>
                        <p>影像处理系统 BIONZ 清晰原始数据降噪</p>
                        <p>DRO优化功能（标准模式）</p>
                        <p>自动对焦方式： 单按自动对焦/监控自动对焦</p>
                        <p>自动对焦区域 多区域(9点)/中央偏重/自由点(可触摸式液晶屏)</p>
                        <p>对焦模式： 自动对焦/微距对焦/对焦预设/放大镜对焦</p>
                        <p>光圈值： 自动(F3.5-F10)/程序自动(F3.5-F10)</p>
                        <p>快门速度：自动(1/4-1/1000)/程序自动(1&rdquo;-1/1000)</p>
                        <p>防抖方式：光学</p>
                        <p>曝光补偿：（+/-2.0EV，1/3EV级）</p>
                        <p>白平衡设定：自动/日光/多云/荧光灯1/荧光灯2/荧光灯3/白炽灯/闪光灯</p>
                        <p>测光模式：多重/中央偏重/定点</p>
                        <p>ISO感光度设定：（菜单，自动/80/100/200/400/800/1600/3200）</p>
                        <p>曝光模式：自动/程序自动/场景选择（10种模式）</p>
                        <p>场景选择：夜景/夜景人像/柔和人像/风景/海滩/雪景/ 烟火/高速快门/高感光度/笑脸快门</p>
                        <p>人脸检测：（触摸/连续）</p>
                        <p>色彩模式：逼真/自然/黑白/棕褐色</p>
                        <p>闪光灯模式：自动/强制闪光/禁止闪光/慢速同步</p>
                        <p>内置闪光灯理想距离：</p>
                        <p>ISO自动：约0.1-约3.2m（W）/约0.25-约2.8m（T），</p>
                        <p>SO3200：最高约6.4m（W）/约5.6m（T）</p>
                        <p>红眼减弱： 自拍计时器：（10秒 / 2秒 /关）</p>        </div>
                </div>
            </div>
            <div class="clear blank"></div>
            <div class="product-auto white-bg">
                <div class="news-title">
                    <h2>最后更新</h2>
                </div>
                <ul>
                    <li><a href="19.html"><i><img src="../../assets/images/pic06.jpg"></i>
                        <h2>商品名称：索尼数码相机DSC-T2</h2>
                        <p>镜头。卡尔·蔡司镜头 (Vario-Tessar)，镜头结构：9组11片（包括3片非球面镜，1片棱镜）。光学变焦：3倍</p>
                        <span class="price-area"><em>￥</em>100.00</span><span class="pics-btn">立即购买</span>
                    </a></li>
                </ul>
            </div>
            <div class="ad ad-big"><a href='http://menhu.yangqq.com/e/public/ClickAd?adid=16' target=_blank><img src='http://menhu.yangqq.com/d/file/p/2019/05-11/82c0a8be75a4fa8d152cae2cdc05d1c4.jpg' border=0 width='830' height='140' alt=''></a></div>
            <div class="pinglun-box white-bg">
                <div class="news-title">
                    <h2>文章评论</h2>
                </div>
                <!-- 评论 开始 -->
                <div class="pinglun">
                    <div class="pl-520am" data-id="19" data-classid="28" data-showhot="0"></div>
                </div>
                <!-- 评论 结束 -->
            </div>
        </div>
        <aside class="side-section right-box">
            <div class="side-tab">
                <ul class="side-tab-ul">
                    <li class="sidetab-current">站长推荐</li>
                    <li>点击排行</li>
                </ul>
                <div id="sidetab-content">
                    <section>
                        <div class="rec">
                            <ul>
                                <li><a href="19.html" title="商品名称：索尼数码相机DSC-T2" target="_blank"><i><img src="../../assets/images/pic06.jpg"></i>
                                    <p>商品名称：索尼数码相机DSC-T2</p>
                                </a></li>
                            </ul>
                        </div>
                    </section>
                    <section>
                        <div class="sort-box">
                            <ul>
                                <li><i></i><a href="19.html" title="商品名称：索尼数码相机DSC-T2" target="_blank">商品名称：索尼数码相机DSC-T2</a></li>
                            </ul>
                        </div>
                    </section>
                </div>
            </div>
            <div class="ad ad-small"><a href='https://promotion.aliyun.com/ntms/act/qwbk.html?userCode=l1qstn8f' target=_blank><img src='http://menhu.yangqq.com/d/file/p/2019/05-11/d27278b3e3d7e3dabf07fcee6fc54dc1.jpg' border=0 width='320' height='132' alt=''></a></div>
            <div class="white-bg product-love">
                <h2 class="side-title">猜你喜欢</h2>
                <ul>

                    <li><a href="19.html"><i><img src="../../assets/images/pic06.jpg"></i>
                        <h2>商品名称：索尼数码相机DSC-T2</h2>
                        <p>镜头。卡尔·蔡司镜头 (Vario-Tessar)，镜头结构：9组11片（包括3片非球面镜，1片棱镜）。光学变焦：3倍</p>
                        <span class="price-area"><em>￥</em>100.00</span><span class="pics-btn">立即购买</span></a></li>
                </ul>
            </div>
            <div class="clear blank"></div>
            <div class="white-bg cloud">
                <h2 class="side-title">标签云</h2>
                <ul>
                    <a href="../e/tags/index-tagid=2&amp;tempid=8.html" target="_blank">3(1)</a> <a href="../e/tags/index-tagid=49&amp;tempid=8.html" target="_blank">视频教程(1)</a> <a href="../e/tags/index-tagid=54&amp;tempid=8.html" target="_blank">建站流程(1)</a> <a href="../e/tags/index-tagid=61&amp;tempid=8.html" target="_blank">帝国cms(1)</a> <a href="../e/tags/index-tagid=52&amp;tempid=8.html" target="_blank">企业网站(10)</a> <a href="../e/tags/index-tagid=43&amp;tempid=8.html" target="_blank">网页设计(1)</a> <a href="../e/tags/index-tagid=13&amp;tempid=8.html" target="_blank">思源夜景(1)</a> <a href="../e/tags/index-tagid=57&amp;tempid=8.html" target="_blank">运营(1)</a> <a href="../e/tags/index-tagid=45&amp;tempid=8.html" target="_blank">网页布局(1)</a> <a href="../e/tags/index-tagid=1&amp;tempid=8.html" target="_blank">2(1)</a> <a href="../e/tags/index-tagid=47&amp;tempid=8.html" target="_blank">今夕何夕(1)</a> <a href="../e/tags/index-tagid=38&amp;tempid=8.html" target="_blank">网站制作(1)</a> <a href="../e/tags/index-tagid=37&amp;tempid=8.html" target="_blank">建站(1)</a> <a href="../e/tags/index-tagid=19&amp;tempid=8.html" target="_blank">心情(1)</a> <a href="../e/tags/index-tagid=20&amp;tempid=8.html" target="_blank">程序员(7)</a> <a href="../e/tags/index-tagid=51&amp;tempid=8.html" target="_blank">音乐(1)</a> <a href="../e/tags/index-tagid=39&amp;tempid=8.html" target="_blank">程序源码(1)</a> <a href="../e/tags/index-tagid=42&amp;tempid=8.html" target="_blank">搜索排名(1)</a> <a href="../e/tags/index-tagid=46&amp;tempid=8.html" target="_blank">个人博客模板(1)</a> <a href="../e/tags/index-tagid=32&amp;tempid=8.html" target="_blank">设计(1)</a>      </ul>
            </div>
        </aside>
    </div>
</template>

<script>
    export default {
        name: "Detail"
    }
</script>

<style scoped>

</style>